<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Seiten</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Verwüstet:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">Mit Trashed</option>
          <option value="only">Nur Trashed</option>
        </select>
      </search-filter>
      <inertia-link class="btn-green" :href="route('pages.create')">
        <span>Seite</span>
        <span class="hidden md:inline">erschaffen</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Titel</th>
          <th class="px-6 pt-6 pb-4">Inhalt</th>
          <th class="px-6 pt-6 pb-4">Status</th>
        </tr>
        <tr v-for="page in pages.data" :key="page.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-kreditgenie-text-green" :href="route('pages.edit', page.id)">
              {{ page.title }}
              <icon v-if="page.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('pages.edit', page.id)" tabindex="-1">
              {{ page.content | stripHTML }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('pages.edit', page.id)" tabindex="-1">
              {{ page.status }}
            </inertia-link>
          </td>
        </tr>
        <tr v-if="pages.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Keine Seiten gefunden.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="pages.links" />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import Icon from '../../Shared/Icon'

export default {
  metaInfo: { title: 'Contacts' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    pages: Object,
  },

  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },

  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('pages'), pickBy(this.form), { preserveState: true })
      }, 100),
    },
  },

  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },

  filters: {
    stripHTML: function(string) {
      return string.replace(/<\/?[^>]+>|&nbsp;/ig, ' ')
    },
  },

}
</script>
